import { render, staticRenderFns } from "./ImportPartnerService.vue?vue&type=template&id=2a84666e&scoped=true"
import script from "./ImportPartnerService.vue?vue&type=script&lang=js"
export * from "./ImportPartnerService.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a84666e",
  null
  
)

export default component.exports